import type { VolWorkspaceDocument } from "./volWorkstationTypes";

export function exportVolLayout(doc: VolWorkspaceDocument, curveId: string) {
  const blob = new Blob([JSON.stringify(doc, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `vol-workspace-${curveId.replace(/:/g, "_")}.json`;
  a.click();
  URL.revokeObjectURL(url);
}

export function importVolLayoutFromFile(): Promise<VolWorkspaceDocument> {
  return new Promise((resolve, reject) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "application/json,.json";
    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) {
        reject(new Error("no file"));
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        try {
          resolve(JSON.parse(String(reader.result)) as VolWorkspaceDocument);
        } catch (e) {
          reject(e);
        }
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsText(file);
    };
    input.click();
  });
}
